/*
 * Header region dropdown — jumps to the selected frank green store.
 * Mirrors the live store's behaviour: change the select, go to that domain.
 */
(function () {
  function bind(select) {
    if (select.dataset.regionSelectorBound === 'true') return;
    select.dataset.regionSelectorBound = 'true';

    select.addEventListener('change', function () {
      if (!select.value) return;
      window.location.href = select.value;
    });
  }

  function init() {
    document.querySelectorAll('[data-region-selector]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The header re-renders in the theme editor, so re-bind after section loads.
  document.addEventListener('shopify:section:load', init);
})();
